import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import { hoverable } from '~theme/snippets';
export const RegenerateButtonInner = styled.div`
	position: relative;
	display: flex;
	width: 100%;
	height: 100%;
	pointer-events: none;
`;

export const RegenerateButtonWrapper = styled.div`
	display: inline-flex;
	width: 32px;
	height: 32px;
	${hoverable};
	flex-shrink: 0;
	border-radius: 100%;
	margin-top: 6px;
	margin-left: 8px;
	background-color: var(--color-white-xs);
	box-shadow: 0 0 12.8px 0 var(--color-rose-58-solid) inset;

	@media (hover: hover), (-moz-touch-enabled: 0), (pointer: fine) {
		&:hover {
			svg {
				transform: rotate(-180deg);
				transition: transform 0.35s ease-in-out;
			}
		}
	}
	&:active {
		${RegenerateButtonInner} {
			transform: scale(0.95);
		}
	}
	svg {
		margin: auto;
	}
`;

export const LoadingStyle = css`
	@keyframes anim {
		to {
			transform: rotate(-360deg);
		}
	}
	svg {
		animation: anim 1s infinite !important;
	}
`;

export const hiddenInTouchscreen = css`
	@media (pointer: coarse) {
		display: none;
	}
`;
